import {enumType} from 'common/enumType';
import i18n from 'i18n';

export const TriggerOption = enumType({
   FileLocking: i18n.t('None'),
   Name: i18n.t('File Locking'),
   IDLE: i18n.t('Trigger Name'),
   None: i18n.t('File Idle Time'),
} as const);

export type TriggerOptionUnion = keyof typeof TriggerOption.enum;
